import { Column } from '@mode/shared/contract-common';
import { SchemaTabs } from '../common/types';
import { EDITOR_ACTIONS, EditorActionType } from '@mode/legacy/util-domain';

export { EDITOR_ACTIONS, EditorActionType };

export const selectChart = (
  focus: boolean,
  model: { view: any; color_palette_token: string; token: string; view_version: number },
  query: any
) => ({
  type: EDITOR_ACTIONS.SelectChart,
  focus,
  model,
  query,
});

export const selectTable = (focus: boolean, model: any, query: any) => ({
  type: EDITOR_ACTIONS.SelectTable,
  focus,
  model,
  query,
});

export const selectQuery = (token: string, focus: boolean, query: any) => ({
  type: EDITOR_ACTIONS.SelectQuery,
  token,
  query,
  focus,
});

export const remapQuery = (newToken: string, oldToken: string) => ({
  type: EDITOR_ACTIONS.RemapSelectedQuery,
  newToken,
  oldToken,
  focus,
});

export const selectReport = (report, currentVisualIds: Array<string>, query: any) => ({
  type: EDITOR_ACTIONS.SelectReport,
  report,
  currentVisualIds,
  query,
});

export const selectTableColumn = (token: string, column: string) => ({
  type: EDITOR_ACTIONS.SelectTableColumn,
  token,
  column,
});

export const toggleSecondarySidebar = () => ({
  type: EDITOR_ACTIONS.ToggleSecondarySidebar,
});

export const minimize = (name: string, queryToken: string) => ({
  type: EDITOR_ACTIONS.ToggleMinimize,
  name,
  queryToken,
});

export const maximize = (name: string, queryToken: string) => ({
  type: EDITOR_ACTIONS.ToggleMaximize,
  name,
  queryToken,
});

export const queryRunComplete = (queryToken: string) => ({
  type: EDITOR_ACTIONS.QueryRunComplete,
  queryToken,
});

export const setView = (name: string, show: boolean) => ({
  type: EDITOR_ACTIONS.SetView,
  name,
  show,
});

export const setQueryMode = (enabled: boolean) => ({
  type: EDITOR_ACTIONS.SetQueryMode,
  enabled: enabled,
});

export const setBuilderMode = (withoutPreview?: boolean) => ({
  type: EDITOR_ACTIONS.SetBuilderMode,
  withoutPreview,
});

export const setNotebookShown = (shown: boolean) => ({
  type: EDITOR_ACTIONS.SetNotebookShown,
  shown,
});

export const clearSelected = () => ({
  type: EDITOR_ACTIONS.ClearSelected,
});

export const toggleVerticalMode = () => ({
  type: EDITOR_ACTIONS.ToggleVerticalMode,
});

export const NotebookRunning = () => ({
  type: EDITOR_ACTIONS.NotebookRunning,
});

export const NotebookWarning = () => ({
  type: EDITOR_ACTIONS.NotebookWarning,
});

export const NotebookLoading = () => ({
  type: EDITOR_ACTIONS.NotebookLoading,
});

export const NotebookStartSession = () => ({
  type: EDITOR_ACTIONS.NotebookStartSession,
});

export const NotebookSessionLost = () => ({
  type: EDITOR_ACTIONS.NotebookSessionLost,
});

export const NotebookReady = () => ({
  type: EDITOR_ACTIONS.NotebookReady,
});

export const NotebookDataOld = () => ({
  type: EDITOR_ACTIONS.NotebookDataOld,
});

export const NotebookDataLoaded = () => ({
  type: EDITOR_ACTIONS.NotebookDataLoaded,
});

export const NotebookTerminated = (reason: string) => ({
  type: EDITOR_ACTIONS.NotebookTerminated,
  reason,
});

export const ReportRunDataLoaded = () => ({
  type: EDITOR_ACTIONS.ReportRunDataLoaded,
});

export const SelectSchemaTab = (tab: SchemaTabs) => ({
  type: EDITOR_ACTIONS.SelectSchemaTab,
  tab: tab,
});

export const OpenFilterPanel = () => ({
  type: EDITOR_ACTIONS.OpenFilterPanel,
});

export const CloseFilterPanel = () => ({
  type: EDITOR_ACTIONS.CloseFilterPanel,
});

export const ToggleFilterPanel = () => ({
  type: EDITOR_ACTIONS.ToggleFilterPanel,
});

export interface UpdateQueryEditorAction {
  type: EditorActionType.UpdateQueryEditor;
  payload: {
    text: string;
    selectionLead: number;
    selectionAnchor: number;
    selectedQueryToken: string;
  };
}

export interface InsertQueryText {
  type: EditorActionType.InsertQueryText;
  payload: {
    text: string;
    selectedQueryToken: string;
    selectionStart: number;
  };
}

export interface RunPreviewTableQueryProps {
  tableSchema: string;
  tableName: string;
  tableColumns?: Column[];
  buttonLocation: string;
  searchQuery: string;
}

export interface RunPreviewTableQueryPayload extends RunPreviewTableQueryProps {
  selectedQueryToken: string;
}

export interface RunPreviewTableQueryAction {
  type: EditorActionType.RunPreviewTableQuery;
  payload: RunPreviewTableQueryPayload;
}

export interface ToggleNotebookSidebarAction {
  type: EditorActionType.ToggleNotebookSidebar;
}

export interface ToggleFilterPanel {
  type: EditorActionType.ToggleFilterPanel;
}

export interface OverrideFilterPanel {
  type: EditorActionType.OverrideFilterPanel;
  isOpen: boolean;
}

export interface TrackEditSession {
  type: EditorActionType.TrackEditSession;
  payload: {
    queryToken: string;
    session: AceAjax.IEditSession;
    undoStack: AceAjax.UndoManager;
  };
}

export type EditorActions =
  | ToggleNotebookSidebarAction
  | ToggleFilterPanel
  | OverrideFilterPanel
  | UpdateQueryEditorAction
  | InsertQueryText
  | RunPreviewTableQueryAction
  | TrackEditSession;
